/* global bocAmchart */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.blankPostProcessor = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doBlankPostProcessor(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 * Produces and returns an array of data based on the valet data
 *
 * @param {object} data Object containing the valet data sets
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doBlankPostProcessor = function (data, dataLoader, chart) {

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data before the blankPostProcessor:",
            bocAmchart.debugClone(chart),
            data
        );
    }

    var customSeriesXY = false;
    if (chart.bocSettings.args.hasOwnProperty('addxygraphs') && chart.bocSettings.args.addxygraphs) {
        customSeriesXY = true;
    }

    if (chart.type !== 'xy' || customSeriesXY) {
        // Collect all the series available in the data
        var seriesSet = [];

        var skipCategoryField = [];
        if (customSeriesXY) {
            chart.graphs = [];
            for (var property in chart.bocSettings.args) {
                if (chart.bocSettings.args.hasOwnProperty(property) && property.endsWith("xfield")) {
                    skipCategoryField.push(chart.bocSettings.args[property]);
                }
            }
        } else {
            skipCategoryField.push(chart.categoryField);
        }

        data.forEach(function (set) {
            for (var property in set) {
                if (set.hasOwnProperty(property) &&  skipCategoryField.indexOf(property) === -1 && seriesSet.indexOf(property) === -1) {
                    seriesSet.push(property);
                }
            }
        });

        seriesSet.forEach(function (term) {
            bocAmchart.addGraph(chart, term, term);
        });
    }


    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, data);
    }

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Data after the blankPostProcessor:",
            bocAmchart.debugClone(chart),
            data
        );
    }

    return data;
};
